//#region Function Imports
import React, { useEffect, useState } from 'react';
import { StyleSheet, View, Platform, useWindowDimensions } from 'react-native';
import { createDrawerNavigator } from '@react-navigation/drawer';
import Ionicons from "@react-native-vector-icons/ionicons/static";
import { useTranslation } from 'react-i18next';
import CustomButton from '../../components/CustomButton/CustomButton';
import { useTheme } from '@react-navigation/native';
import CustomDrawer from '../../components/CustomDrawer/CustomDrawer';
import MyAccountScreen from "../../screens/SelfService/MyAccount/MyAccountScreen";
import Home from '../../screens/Home';
import HomePageZero from '../../screens/HomeShortcutsPage/HomePageZero';
import { useSettings } from '../../hooks/useSettings';
import SettingsScreen from '../../screens/Settings/SettingsScreen';
import { useAuthContext } from '../../hooks/useAuthContext';

//#endregion

const Drawer = createDrawerNavigator();

const DrawerNavigation = (props) => {

    //#region Function Definitions
    const { t } = useTranslation();
    const { colors } = useTheme();
    const { user } = useAuthContext();
    const [time, setTime] = useState(new Date().getHours());
    const [drawerTitle, setDrawerTitle] = useState("")
    const { width, height } = useWindowDimensions();
    const styles = makeStyles(colors, width);
    const { getSettings, getEmployeeTabs, getTrainingTabs } = useSettings();

    //* Check user rights and give high level access
    //* HR Task Admin with no other access
    const checkUserRights = () => {
        let giveAccess = false;
        return true;
    }
    //#endregion

    //#region Use Effect
    // * Refresh settings only on page refresh because this is not changin often. 
    // * The all the settings are set in states in useSetting and could be fedged in there 
    useEffect(() => {
        getSettings().catch(console.error)
        getEmployeeTabs().catch(console.error)
        getTrainingTabs().catch(console.error)
    }, [])

    useEffect(() => {
        if (time >= 0 && time < 12) {
            setDrawerTitle(t('common:welcomeMorning'))
        } else if (time >= 12 && time < 18) {
            setDrawerTitle(t('common:welcomeAfternoon'))
        } else if (time >= 18 && time <= 23) {
            setDrawerTitle(t('common:welcomeEvening'))
        }
    },[time, t]);

    useEffect(
        () => {
            // * No need to do anything here
        },
        [width, height]
    );
    //#endregion

    return (
        <Drawer.Navigator
            initialRouteName={props.loadDrawer}
            drawerContent={props => <CustomDrawer {...props} />}
            screenOptions={({ navigation }) => {
                const screenOptions = {
                    headerShown: true,
                    headerStyle: {
                        backgroundColor: Platform.OS === 'web' ? '#FFF' : colors.background_header
                    },
                    headerTintColor: colors.text_primary,
                    headerTitleStyle: { fontWeight: 'bold' },
                    headerTitleAlign: 'center',
                    drawerActiveTintColor: colors.buttons_primary,
                    drawerInactiveTintColor: colors.text_primary, //'#ccc',
                    drawerStyle: {
                        backgroundColor: colors.background,
                    },
                    drawerLabelStyle: {
                        fontSize: 15,
                        color: colors.text_primary,
                    },
                    headerBackButtonDisplayMode: 'minimal',
                    headerRight: (props) => (
                        Platform.OS !== 'web' && (
                            <View
                                style={styles.row}>
                                <CustomButton
                                    iconName='megaphone-outline'
                                    onPress={() => { navigation.navigate('HomePageZero') }}
                                    show='HOME_BELL'
                                    type='HOME_BELL'
                                    textTop='2'
                                    sz={25}
                                />
                                {/* <CustomButton
                            iconName='person-outline'
                            onPress={() => { navigation.navigate('MyAccountScreen') }}
                            show='HOME_BELL'
                            type='HOME_BELL'
                            textTop='2'
                            sz={25}
                        /> */}
                            </View >
                        )
                    ),
                };
                if (Platform.OS !== 'web') {
                    screenOptions.drawerType = 'slide';
                    screenOptions.drawerStyle = {
                        width: width / 1.25,
                        minWidth: width / 1.25,
                        maxWidth: width / 1.25,
                    };
                }

                return screenOptions;
            }}
        >

            <Drawer.Screen
                name="Home"
                component={Home}
                options={{
                    drawerIcon: ({ focused, size }) => (
                        <Ionicons
                            name="home-outline"
                            size={size}
                            color={focused ? '#86BC25' : '#ccc'}
                        />),
                    headerTitleStyle: {
                        fontWeight: 'bold'

                    },
                    headerTitle: drawerTitle,
                    title: Platform.OS === 'web' ? '' : t('navigate:home')
                }}
            />
            {Platform.OS === 'web' && checkUserRights() && <Drawer.Screen
                name="HRAdmin"
                component={HRAdmin}
                options={{
                    drawerIcon: ({ focused, size }) => (
                        <Ionicons
                            name="people-outline"
                            size={size}
                            color={focused ? '#86BC25' : '#ccc'}
                        />),
                    headerTitleStyle: {
                        fontWeight: 'bold'
                    },
                    headerTitle: drawerTitle,
                    title: Platform.OS === 'web' ? '' : t('navigate:hrAdmin')
                }}
            />
            }
            <Drawer.Screen
                name="MyAccountScreen"
                component={MyAccountScreen}
                options={{
                    title: t('navigate:myprofile'),
                    drawerItemStyle: { height: 0 },
                    drawerIcon: ({ focused, size }) => (
                        <Ionicons
                            name="person-outline"
                            size={size}
                            color={focused ? '#86BC25' : '#ccc'}
                        />),
                    headerTitleStyle: {
                        fontWeight: 'bold'

                    }
                }}
            />

            <Drawer.Screen
                name="SettingsScreen"
                options={{
                    title: t('navigate:settings'),
                    drawerItemStyle: { height: 0 }
                }}
            >
                {props => <SettingsScreen {...props} isAdmin={checkUserRights()} />}
            </Drawer.Screen>
            <Drawer.Screen
                name="HomePageZero"
                component={HomePageZero}
                options={{
                    title: t('navigate:AN'),
                    drawerItemStyle: { height: 0 }
                }}
            />

        </Drawer.Navigator>

    );
};

const makeStyles = (colors, width) => StyleSheet.create({
    main: {
        flex: 1,
        justifyContent: 'flex-start',
        paddingTop: -100,
        paddingBottom: -100,
    },
    row: {
        flexDirection: 'row',
        justifyContent: 'center',
        margin: (Platform.OS === 'web' && width > 1300) ? 15 : 0,
    },
});

export default DrawerNavigation;